export default {
  name: 'Content section - 8',
  tab: 'content',
  type: 'content-default-section',
  content: {
    title: 'Content section',
    introtext:
      '<p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Nulla vitae elit libero, a pharetra augue. Vestibulum id ligula porta felis euismod semper. Sed posuere consectetur est at lobortis. Curabitur blandit tempus porttitor. Cras mattis consectetur purus sit amet fermentum.</p>',
    image: '',
    buttons: '[]'
  },
  design: {
    'background-color': 'var(--primary-color)',
    'background-image': '',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '100px',
    'padding-bottom': '100px',
    'title-color': 'var(--text-light-color)',
    'title-font-weight': 'lighter',
    'title-tag': 'h2',
    'introtext-color': 'var(--text-light-color)'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'lg',
    'content-horizontal-alignment': 'center',
    'content-box': '1',
    'content-box-color': 'white',
    'content-box-padding': '50px',
    'content-box-opacity': '0.05',
    'content-box-elevation': '0',
    'content-box-border': '0',
    'content-box-border-color': 'inherit',
    'content-box-rounded': '1'
  },
  advanced: {}
}
